import { Box, type BoxProps, Typography } from "@mui/material";

export type BaseKeyValueProps = {
  keyLabel: string;
  children?: React.ReactNode;
} & BoxProps;

export const BaseKeyValue = ({
  keyLabel,
  children,
  sx,
  ...props
}: BaseKeyValueProps) => {
  return (
    <Box
      {...props}
      sx={{
        ...sx,
        display: "flex",
        borderBottom: "1px solid",
        borderColor: "grey.200",
        ":first-of-type": {
          borderTop: "1px solid",
          borderColor: "grey.200",
        },
      }}
    >
      <Box
        p={2}
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        width="104px"
        bgcolor="grey.50"
      >
        <Typography variant="body2">{keyLabel}</Typography>
      </Box>
      <Box p={2} fontSize="14px" flex={1}>
        {children}
      </Box>
    </Box>
  );
};
